import { UpliftRule } from '@rygen/rygen-ui/model';

export class RateUplift extends UpliftRule {
  upliftRuleId?: number;
  upliftRateUnit?: string;

  constructor(opts?: Partial<RateUplift>) {
    super(opts);

    if (opts?.upliftRuleId != null) {
      this.upliftRuleId = opts.upliftRuleId;
    }
    if (opts?.upliftRateUnit != null) {
      this.upliftRateUnit = opts.upliftRateUnit;
    }
  }
}
